<template>
  <div class="animated fadeIn">
    <!-- <Navigator :title="routeTitle" :navItems="nav"></Navigator> -->
    <DataTable :viewMode="'EM'"/>
  </div>
</template>

<script>
import nav from '../../_nav';
import DataTable from '../../components/datatable/DataTable';
import consts from '../../_consts';
import {
  Navigator
} from '../../components/commons';
export default {
  name: 'events-manager',
  components: {
    DataTable,
    Navigator
  },
  data () {
    return {
      nav: nav.managerNav
    }
  },
  created () {
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', consts.viewNames.managerEvent);
  }
};
</script>


<style>

</style>



// WEBPACK FOOTER //
// EventsManager.vue?fd19631a